export default __webpack_public_path__ + "static/media/for_way3.09b275af.png";